import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";
import { invalidateShiftQueries } from "./invalidateShiftQueries";
import { trackEvent } from "../../../shared/lib/analytics";

export function useBulkUpdateShiftStatusMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: plantoesApi.updateStatusBulk,
    onSuccess: (_, { acao }) => {
      if (acao === "marcar_recebido") trackEvent("plantao_marcado_recebido");
      invalidateShiftQueries(queryClient);
    },
  });
}
